var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

var site = site || {};

site.drawers = site.drawers || {};
// Disable sticky footer on mobile.
site.drawers.disableStickyFooterMobile = true;

(function ($) {
  Drupal.behaviors.productFullV1 = {
    switchToTab: function (args) {
      var _args = args || {};
      var id = _args.$trigger.data('tab-id');
      var content = _args.$trigger.data('tab-content');
      var $trigger = _args.$triggers.filter('[data-tab-id=' + id + ']');
      var $activeContent = _args.$content.filter('[data-tab-content=' + content + ']');

      // Show this tab content
      _args.$content.removeClass('current');
      _args.$triggers.removeClass('current');
      $activeContent.addClass('current');
      $trigger.addClass('current');

      // Set event that other modules can listen in on if needed.
      $(document).trigger('product:tab', {
        id: id,
        content: $activeContent
      });
    },
    setTabs: function ($content, $triggers, context) {
      var self = this;

      $triggers.off('click.tabbedBlock').on('click.tabbedBlock', function (event) {
        var $this = $(this);
        var tabsPadding = parseInt($this.parent().css('padding-left'), 10);
        var $prevlemets = $this.prevAll();
        var fullWidth = parseInt($(window).width(), 10);
        var scrolltoWidth = 0;

        $prevlemets.each(function () {
          scrolltoWidth += parseInt($(this).outerWidth(true), 10);
        });

        scrolltoWidth += parseInt($this.outerWidth(true), 10);
        scrolltoWidth += tabsPadding;
        scrolltoWidth += 40;
        scrolltoWidth -= fullWidth;
        $triggers.parent().animate({
          scrollLeft: scrolltoWidth
        }, 350);
        event.preventDefault();
        self.switchToTab({
          $trigger: $this,
          $triggers: $triggers,
          $content: $content
        });
      });
    },
    earlyAccessCopy: function (prodID, context) {
      var product = prodcat.data.getProduct(prodID);
      var skus = product.skus;
      var skusLength = skus.length;
      var $earlyAccess = $('.js-product-early-access', context);

      $earlyAccess.addClass('hidden');
      if (skusLength > 0) {
        for (var i = 0; i < skusLength; i++) {
          if (skus[i].RESTRICT_GROUP === 1) {
            $earlyAccess.removeClass('hidden');
            break;
          }
        }
      }
    },
    toggleShow: function ($item, $tabs, $accordionContent) {
      var self = this;
      var group = $item.data('actabGroup');

      if (!self.isMobile) {
        $accordionContent.removeClass('accordion-active');
        $tabs.removeClass('accordion-active');
      }
      var $accordionItem = $item.closest('.js-accordion-item').length > 0 ?
        $item.closest('.js-accordion-item') :
        $accordionContent.filter('[data-actab-group="' + group + '"]');

      if (self.isMobile) {
        $accordionItem.toggleClass('accordion-active');
        $item.toggleClass('accordion-active');
      } else {
        $accordionItem.addClass('accordion-active');
        $item.addClass('accordion-active');
      }
    },
    isMobile: false,
    attachRetriesIncremental: 0,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-product-full-v1', context);

      // Re-attach 10 times max, waiting for prodcat.
      if (typeof prodcat?.data === 'undefined' && self.attachRetriesIncremental < 10) {
        self.attachRetriesIncremental++;
        setTimeout(function() {
          self.attach(context);
          return;
        }, self.attachRetriesIncremental * 100);
      }
      $modules.each(function () {
        var $product = $(this);
        var $tabs = $('.js-accordion-tab', $product);
        var $accordionContent = $('.js-accordion-item', $product);
        var prodId = $product.data('product-id');
        var skuBaseId = $product.data('sku-base-id');
        var skuData = prodcat.data.getSku(skuBaseId);
        var ingredients = skuData?.ILN_LISTING;
        var $triggers = $('.js-product-full__overview-trigger', $product);
        var $content = $('.js-product-full__tabbed-content', $product);
        var $toggleShadesLink = $('.js-toggle-shade-picker', $product);
        var $overviewTabs = $('.js-product-full__overview-tabs', $product);
        var $sppReviews = $('.js-product-full__rating', $product);
        var $sppReviewsCount = $('.product__rating-count', $product);
        var ingredientGroup = $product.find('.js-accordion-tab.accordion-tab--ingredients').data('actabGroup');

        if (!ingredients) {
          $product.find('.js-product-full-ingredients-title').hide();
          $product.find('.js-product-full-ingredients-content').hide();
          $product.find('.js-accordion-tab.accordion-tab--ingredients').hide();
          $product.find('.js-accordion-item').filter('[data-actab-group="' + ingredientGroup + '"]').hide();
        }

        $toggleShadesLink.once().on('click', function (e) {
          e.preventDefault();
          self.switchToTab({
            $trigger: $(this),
            $triggers: $triggers,
            $content: $content
          });
        });

        self.setTabs($content, $triggers, context);
        $product.trigger('product.sppInit', prodId);
        Unison.on('change', function () {
          var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
          var bPlargeUp = parseInt(Unison.fetch.all()['usn-large'], 10);

          self.isMobile = currentBpWidth <= bPlargeUp;
          if (self.isMobile) {
            $overviewTabs.css('width', $(window).width());
            $accordionContent.removeClass('accordion-active');
            if ($accordionContent.length < 3) {
              $accordionContent.parent().closest('.accordion').css('padding-bottom', '5px');
            }
          } else if (!self.isMobile) {
            self.toggleShow($tabs.first(), $tabs, $accordionContent);
            setTimeout(function () {
              var banHeight = parseInt($('.block-template-site-banner-v1', context).outerHeight(true), 10);
              var thisTop = parseInt($('.product-full__sku-details', context).css('top'), 10) + banHeight;

              if (banHeight > 0) {
                injectStyles('bannerStyle', '.product-full-v1 .sticky { top: ' + thisTop + 'px!important }');
              }
            }, 2000); // sorry!!!

            $('.js-close-site-banner', context).on('click', function () {
              $('#bannerStyle', context).remove();
            });
          }
        });

        $tabs.once().on('click', function () {
          var $this = $(this);

          self.toggleShow($this, $tabs, $accordionContent);
        });
        function injectStyles(id, rule) {
          var div = $('<div />', {
            html: '&shy;<style id="' + id + '">' + rule + '</style>'
          }).appendTo('body');
        }

        $sppReviews.once().on('click', function (e) {
          var $reviewsAnchor = $('#spp-product-layout__reviews');
          var reviewsMargin = 150;
          e.preventDefault();
          $(this).addClass('product-full__rating--clicked');
          if ($reviewsAnchor.length > 0) {
            $('html, body').animate({
              'scrollTop': $reviewsAnchor.offset().top - reviewsMargin
            },
            {
              duration: 1000,
              step: function(now, fx) {
                var newOffset = $reviewsAnchor.offset().top - reviewsMargin;
                if (fx.end !== newOffset) {
                  fx.end = newOffset;
                }
              }
           });
          }
        });

        $sppReviews.once($sppReviews).hover(function () {
          $sppReviewsCount.addClass('product__rating-count-underline');
        }, function () {
          $sppReviewsCount.removeClass('product__rating-count-underline');
        });
        // Displaying early access loyalty copy
        self.earlyAccessCopy(prodId, $product);
      });

      var $smartTrafficBtn = $('.js-smart-traffik');

      $smartTrafficBtn.on('click', function () {
        site.track.evtLink({
          event_name: 'ebooking',
          event_category: 'ebooking',
          event_action: 'click',
          event_label: $smartTrafficBtn.data('st-reference-id')
        });
      });

      var $teesterWrapper = $('.teester-wrapper');

      site.elcEvents.addListener('tealium:teester-loaded', function () {
        var tLinkClicked = false;
        // Once the teester SDK is loaded
        var currentSKU = 0;

        $('.js-product-full-v1').each(function () {
          // Expose the default SKU to teester
          currentSKU = $(this).data('sku-base-id');
          setTimeout(function () {
            window.testTeesterVideo(currentSKU, '.js-teester-link', '#teester-player');
          }, 1);
        });

        $('.js-teester-link').on('click', function (e) {
          e.preventDefault();
          $teesterWrapper.toggleClass('hidden');
          if (window.teesterPlayer !== false) {
            window.teesterPlayer.pause();
          }
          if (tLinkClicked === false) {
            // Don't reload the Teester video if it's already done
            window.updateTeester(currentSKU, '#teester-player');
            tLinkClicked = true;
          }
        });

        $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
          // Updated the Teester video
          currentSKU = skuBaseId;
          tLinkClicked = false;
          $teesterWrapper.addClass('hidden');
          window.testTeesterVideo(currentSKU, '.js-teester-link', '#teester-player');
        });
      });

      $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
        var $product = $(this);

        // Update sku base id on Smart traffik Btn.
        $smartTrafficBtn = $('.js-smart-traffik', $product);
        if ($smartTrafficBtn.length) {
          $smartTrafficBtn.attr('data-st-reference-id', 'SKU' + skuBaseId);
        }

        // Override Product's MISC_FLAG_TEXT by SKU's
        const skuData = prodcat.data.getSku(skuBaseId);
        const $badge = $product.find('.js-product-full__sku-badge');
        let miscFlagText = skuData?.MISC_FLAG_TEXT;

        if (!miscFlagText) {
          const product = prodcat.data.getProduct($product.data('product-id'));

          miscFlagText = product?.MISC_FLAG_TEXT;
        }
        $badge.html(miscFlagText);
      });
    }
  };
})(jQuery);
